import { useSearchParams } from "react-router-dom";

// Stealth UI gate. Returns true when the current URL has
// `?devsoliel_override=true`. Used to hide work-in-progress features from
// non-dev admins without removing them from the bundle.
export default function useDevOverride() {
  const [params] = useSearchParams();
  return params.get("devsoliel_override") === "true";
}
